// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fl-0";
export var fileCarousel = "_fl-2";
export var removeFileButton = "_fl-1";